import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config/api.js

const AddLead = () => {
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [followupDate, setFollowupDate] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('pending'); // Default status
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate(); // For redirecting after adding the lead

    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent the default form submission

        setLoading(true);
        // Prepare the data to be sent to the API
        const leadData = {
            staff_id: 1, // Assuming staff_id is 1 (you can dynamically set this as needed)
            name: name,
            number: number,
            followup_date: followupDate,
            description: description,
            status: status,
        };

        // Send POST request to create a new lead
        fetch(`${BASE_URL}oleads`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(leadData),
        })
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.status === 1) {
                    // Success: Redirect to the lead list or show a success message
                    alert('Lead created successfully');
                    navigate('/OrderLeadList'); // Redirect to leads list
                } else {
                    setError('Failed to create lead');
                }
            })
            .catch((error) => {
                setLoading(false);
                setError('Error creating lead');
                console.error('Error creating lead:', error);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add New Lead</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add a New Lead</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">
                                            Lead Name
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            placeholder="Enter lead name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="number" className="form-label">
                                            Phone Number
                                        </label>
                                        <input
                                            type="number"
                                            id="number"
                                            className="form-control"
                                            placeholder="Enter phone number"
                                            value={number}
                                            onChange={(e) => setNumber(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="followupDate" className="form-label">
                                            Follow-up Date
                                        </label>
                                        <input
                                            type="date"
                                            id="followupDate"
                                            className="form-control"
                                            value={followupDate}
                                            onChange={(e) => setFollowupDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">
                                            Description
                                        </label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            placeholder="Enter description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="status" className="form-label">
                                            Status
                                        </label>
                                        <select
                                            id="status"
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                        >
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>

                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Creating...' : 'Create Lead'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddLead;
